<!--
 * @Author: wsx
 * @Date: 2022-01-05 18:45:47
 * @LastEditTime: 2022-01-12 18:03:34
 * @LastEditors: your name
 * @Description:穿梭框应用
-->
<template>
  <el-dialog
    v-model="dialogVisible"
    title="卡口选择"
    width="50%"
    height="50vh"
    @close="close"
  >
    <div class="TransferApplication" v-loading="loading" v-show="!mapActive">
      <h-transfer
        v-if="treeData.length > 0"
        ref="transferRef"
        v-model="transferKeys"
        nodeKey="cameraId"
        checkedKey="cameraId"
        :props="{ value: 'treeId', label: 'resourceName' }"
        :data="treeData"
        :default-expanded-keys="[rootNodeKey]"
        :titles="['待选', '已选']"
        :areaCameraArry="areaCameraArry"
        :showDefineTree="true"
        :showEquipmentType="true"
      >
      </h-transfer>
    </div>
    <mapSelectTransfer
      class="box-map"
      ref="mapSelectRef"
      v-if="mapActive"
      :allCameraList="videoData.cameraBaseDtls"
      :tranferCameraList="areaCameraArryObj"
    ></mapSelectTransfer>

    <template #footer>
      <div class="dialog-footer">
        <div class="map" @click="changeMapActive">
          <h-icon icon="icon-weizhi" font-size="16"></h-icon>地图选择
        </div>
        <h-button type="primary" @click="emitCheckList">保存</h-button>
        <h-button @click="close">取消</h-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  toRefs,
  ref,
  useSlots,
  watchEffect,
} from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { queryOrganList } from "@/api/system";
import { areaRelation, areaRelationData } from "@/api/system/region.js";
import {
  getResource,
  queryRealVideoTree,
  queryTreeAreaVideo,
  queryAllTreeAreaVideo,
} from "@/api/videoControl/videoApi.js";
import util from "@util/js";
export default defineComponent({
  name: "TransferApplication",
  components: {},
  props: {
    // 展示弹窗
    visible: {
      type: Boolean,
      default: false,
    },
    // 区域信息
    regionInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 表格行信息
    rowInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup(props, { emit }) {
    const data = reactive({
      loading: false,
      mapActive: false,
      dialogVisible: false,
      transferKeys: [],
      treeOrganPerson: [],
      rootNodeKey: "",
      videoData: null,
      treeData: [],
      areaCameraArry: [], // 区域内绑定摄像头  存摄像头ID
      areaCameraArryObj: [], // 区域内绑定摄像头   存摄像头对象
    });
    const refData = toRefs(data);
    const transferRef = ref();
    const mapSelectRef = ref();
    const changeMapActive = () => {
      if (data.loading) {
        ElMessage.warning("请稍等正在加载数据");
        return;
      }
      data.mapActive = !data.mapActive;
      data.areaCameraArryObj = transferRef.value.selectedList;
    };
    watchEffect(() => {
      data.dialogVisible = props.visible;
    });
    // 获取区域树数据
    const queryOrganPersonListAsycn = async () => {
      data.loading = true;
      const params = {
        id: "4",
      };
      const result = await getResource(params);
      result.data.forEach((item) => {
        item.treeId = item.deptId;
        const children = item.userList || [];
        Reflect.deleteProperty(item, "userList");
        children.forEach((p) => {
          p.treeId = "person-" + p.userId;
        });
        item.children = children;
      });
      const options = { pid: "parentId", id: "id", rootPid: 4 };
      const treeData = util.arrayToTree(result.data, options);
      console.log(treeData);
      data.treeOrganPerson = treeData;
      queryRealVideoTreeAsync();
    };
    // 获取区域树中摄像头数据
    const queryRealVideoTreeAsync = async () => {
      // const res = await queryRealVideoTree();
      const res = await queryAllTreeAreaVideo();
      data.videoData = res;
      const arrayGroup = arrayGroupBy(data.videoData.cameraBaseDtls, "deptId");
      const changeArrayGroup = {};
      arrayGroup.forEach((item) => {
        item.forEach((it) => {
          it.resourceName = it.cameraName;
          it.treeId = "device_" + it.deviceId;
        });
        changeArrayGroup[item[0].deptId] = item;
      });
      const changeArrayGroupArray = Object.keys(changeArrayGroup);
      console.log(changeArrayGroup);
      const getChildren = (obj) => {
        for (const key in obj) {
          if (key == "children") {
            obj[key].forEach((item) => {
              getChildren(item);
              if (changeArrayGroupArray.includes(item.resource + "")) {
                changeArrayGroup[item.resource].forEach((it) => {
                  item.children.push(it);
                });
              }
            });
          }
        }
      };
      getChildren(data.treeOrganPerson[0]);
      // data.treeOrganPerson[0].children.push(
      //   ...changeArrayGroup[data.treeOrganPerson[0].resource]
      // );
      data.treeData = data.treeOrganPerson;

      data.loading = false;
    };
    // 获取区域已绑定摄像头
    const queryTreeAreaVideoAsync = async () => {
      const parmas = {
        areaId: props.rowInfo.regionId,
      };
      const result = await queryTreeAreaVideo(parmas);
      nextTick(() => {
        if (result.cameraBaseDtls.length > 0) handleAreaCamera(result);
      });
    };
    // 处理区域摄像头数据
    const handleAreaCamera = (result) => {
      const newCheckedNodeArray = [];

      data.areaCameraArry = result.cameraBaseDtls.map((item) => {
        return (item = JSON.parse(
          JSON.stringify(item).replace(/cameraName/g, "resourceName")
        ));
      });

      data.areaCameraArry.forEach((item) => {
        newCheckedNodeArray.push(item.cameraId);
      });
      data.areaCameraArry = newCheckedNodeArray;
      data.rootNodeKey = data.areaCameraArry[0];
    };
    const emitCheckList = async () => {
      const cameraIds = [];
      //地图界面保存框选数据，否则保存穿梭框数据
      console.log(data.mapActive);
      if (!data.mapActive) {
        if (transferRef.value) {
          transferRef.value.selectedList.forEach((item) => {
            cameraIds.push({
              areaId: props.rowInfo.regionId,
              cameraId: parseInt(item.cameraId),
              cameraInOutType: item.cameraInOutType,
            });
          });
        }
      } else {
        mapSelectRef.value &&
          mapSelectRef.value.selectPoint.forEach((item) => {
            cameraIds.push({
              areaId: props.rowInfo.regionId,
              cameraId: parseInt(item.cameraId),
              cameraInOutType: item.cameraInOutType,
            });
          });
      }
      const params = {
        areaId: props.rowInfo.regionId,
        cameraIds: cameraIds,
      };

      const res = await areaRelationData(params);
      if (res.code == 0) {
        ElMessage.success("保存成功");
      } else {
        ElMessage.error("操作失败");
      }
      close();
    };
    const arrayGroupBy = (list, groupId) => {
      const sorted = groupBy(list, (item) => {
        return [item[groupId]];
      });
      return sorted;
    };
    const groupBy = (arr, f) => {
      const groups = {};
      arr.forEach((o) => {
        const group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });
      return Object.keys(groups).map((group) => {
        return groups[group];
      });
    };
    const close = () => {
      data.dialogVisible = false;
      emit("update:visible", false);
      console.log(5555555);
    };
    queryOrganPersonListAsycn();
    queryTreeAreaVideoAsync();
    return {
      ...refData,
      transferRef,
      mapSelectRef,
      emitCheckList,
      close,
      changeMapActive,
    };
  },
});
</script>
<style lang="scss" scoped>
.el-dialog {
  .TransferApplication {
    height: 50vh;
  }
  .box-map {
    height: 50vh;
  }

  .dialog-footer {
    width: 100%;
    padding-bottom: 8px;
    position: relative;
    .map {
      position: absolute;
      left: 0;
      font-size: 16px;
      line-height: 34px;
      color: brown;
      cursor: pointer;
    }
  }
}
</style>
